import React from 'react'

import './fronthand_style.css';
import './fronthand_media-queries.css';


import U from './assets_1/U.png'
import Scalability from './assets_1/Scalability.png'
import Availability from './assets_1/Availability.png'
import Profitable from './assets_1/Profitable.png'
import Completely from './assets_1/Completely.png'

import Complete from './assets_1/Complete.png'
import core_1 from './assets_1/core_1.png'
import freedom from './assets_1/freedom.png'

import faq_1 from './assets_1/faq_1.png'
import s_m_1 from './assets_1/s_m_1.png'


import { Gen_8_Cal, Fixed_Pool } from './Data_Structure';

function Btn_Click(btn_id) {
    
    const btn = document.getElementById(btn_id);

    const ans = btn.nextElementSibling;
    const span2 = btn.children[1];
    const item1 = span2.children[0];
                    
    ans.classList.toggle('show');
    item1.classList.toggle('rotate');
    // span2.classList.toggle

}

export default function CoreUnity_Before_Login(props) {

    function Transfer_To_Btn(c_add) {
        try {
            // window.location.href = "https://scan.coredao.org/address/" + c_add;
            window.open("https://scan.coredao.org/address/" + c_add, "_blank");
        }
        catch(error) {
            console.log(error);
        }
    }

  return (
    <>
        {/* <!------Main---Content--------------------------> */}
        <div className="f-main-content">
            <header>
                {/* <!-- <div className="">
                    
                </div> --> */}
                <div className="back-grid-header">
                    <div className="back-grid-header-left">
                        {/* <!-- <div className="logo"> <img src="./assets/Logo__3.png" alt=""/></div> -->
                        <!-- <div className="logo"> <img src="./assets/Logo__1.png" alt=""/></div> --> */}
                       <div className="logo">
                            <div>CORE</div>
                            <div>UNITY</div>
                       </div>    
                    </div>
                    <div className="back-grid-header-blank">
                        <span></span>
                    </div>
                    <div className="back-grid-header-right">
                        <div className="btn-link">
                            <div><a onClick={() => {props.SignIn_Click(true)}}>Log In</a></div>
                        </div>
                    </div>
                </div>    
            </header>

            {/* <!-------Main----Cards-----> */}
            <main>
                <div className="back-grid">
                    <div className="dash-main">
                        <div className="dash-card-main">           
                            <div className="dash-main-left">
                                <span>WELCOME YOU TO</span>
                                <div>CORE UNITY</div>
                                <p>
                                    A FUTURE REVOLUTION CONNECTING ALL DIGITAL PLATFORMS WORLDWIDE.
                                </p>
                                <span></span>
                                <div className="btn-action">
                                    <span><a onClick={() => {props.SignIn_Click();}}>Log In</a></span>
                                    <span><a onClick={() => {
                                        props.SignUp_Click();
                                    }}>Sign Up</a></span>
                                </div>
                            </div>
                            
                            <div className="dash-main-right">
                                <div className="dash-img">
                                    <span><img src={U} alt=""/></span>
                                </div>
                            </div>            
                        </div>
                    </div>
                </div>
                {/* <!------Smart----Contract---------------------------------> */}

                <div className="back-grid-short">                                 
                    <div className="heading">
                        <span>Smart Contract</span>
                        <div className="sub-heading">
                            <span>Features Of</span>
                        </div>
                    </div>
                </div>
                <div className="back-grid">
                    <div className="dash-triple">
                        <div className="card-triple">
                            <div className="card-logo">            
                                <span><img src={Scalability} alt=""/></span>
                        </div>
                            <div className="sub-heading">
                                <span>Scalability</span>
                            </div>
                            <p>
                                Applications are given a wider variety of ways to be 
                                deployed in CORE because of its scalability and highly 
                                effective smart contract.
                            </p>
                        </div>
                        <div className="card-triple">
                            <div className="card-logo">            
                                <span><img src={Availability} alt=""/></span>
                        </div>
                            <div className="sub-heading">
                                <span>Availability</span>
                            </div>
                            <p>
                                More reliable network structure, user asset, intrinsic 
                                value, and a higher degree of decentralization consensus come...
                            </p>
                        </div>
                        <div className="card-triple">
                            <div className="card-logo">            
                                <span><img src={Profitable} alt=""/></span>
                        </div>
                            <div className="sub-heading">
                                <span>Profit Generated</span>
                            </div>
                            <p>
                                Referral bonus that pays up to Unlimited levels.
                                Transparently programmed using a smart contract created 
                                on the CORE Blockchain.
                            </p>
                        </div>
                    </div>
                </div>

                {/* <!-----About----Section-------------------------------> */}
               
                <div className="back-grid-short">                                 
                    <div className="heading">
                        <span>About</span>
                        <div className="sub-heading">
                            <span>Features Of</span>
                        </div>
                    </div>
                </div>
                <div className="back-grid">
                    <div className="dash-double">
                        <div className="card-double-blank">
                            <div className="card-double">
                                <div>
                                    <span><img src={U} alt=""/></span>
                                </div>
                            </div>
                            <div className="card-double">    
                                <div className="sub-heading">
                                    <span>About</span>
                                </div>
                                <p>
                                    Core Unity is the international community of the global decentralized ecosystem and the first ever 
                                    smart contract marketing 2x matrix plan of the CORE Blockchain. This is a self-executing software 
                                    algorithm that performs the function of distributing partner rewards between community 
                                    members, subject to certain conditions (Level and matrix marketing plan). 
                                    Information about transactions in the 
                                    CORE Blockchain can always be viewed at the link https://scan.coredao.org/
                                </p>
                                <div className="sub-heading">
                                    <span>POWER Of CORE</span>
                                </div>
                                <p>
                                    It’s been more than 3 years since the most well-known cryptocurrency CORE was launched. 
                                    Now there is a multitude of digital tokens available for traders like you and me to choose from.
                                </p>
                            </div>
                        </div> 
                    </div>
                </div>

                {/* <!-----Core----Blockchain---------------------------------> */}

                <div className="back-grid-short">                                 
                    <div className="heading">
                        <span>CORE Blockchain</span>
                        <div className="sub-heading">
                            <span>Advantages Of</span>
                        </div>
                    </div>
                </div>
                <div className="back-grid">
                    <div className="dash-triple">
                        <div className="card-triple">
                            <div className="card-logo">            
                                <span><img src={Completely} alt=""/></span>
                        </div>    
                            <div className="sub-heading">
                                <span>100% Decentralized</span>
                            </div>
                            <p>
                               Core Unity is completely decentralized smart contract 
                                works on self-execution of technical 
                                functionalities with no admin interference.
                            </p>    
                        </div>
                        <div className="card-triple">
                            <div className="card-logo">            
                                <span><img src={Complete} alt=""/></span>
                        </div>
                            <div className="sub-heading">
                                <span>Can't be Changed</span>
                            </div>
                            <p>
                                Core Unity is complete marketing strategy is represented by a 
                                verified smart contract enlisted on the CORE Blockchain, 
                                which is immutable and can't be changed or altered.
                            </p>
                        </div>
                        <div className="card-triple">
                            <div className="card-logo">            
                                <span><img src={core_1} alt=""/></span>
                        </div>
                            <div className="sub-heading">
                                <span>Low Gas Fee</span>
                            </div>
                            <p>
                                CORE has very low transactions fee. In fact, 
                                they are almost non-existent whenever you 
                                make a transaction, you have to 
                                pay minimum 0.00063 CORE and that’s basically it.
                            </p>
                        </div>
                    </div>
                </div>

                {/* <!-----Financial----Freedom--------------------------------> */}
               
                <div className="back-grid-short">                                 
                    <div className="heading">
                        <span>Financial Freedom</span>
                        <div className="sub-heading">
                            <span>Features Of</span>
                        </div>
                    </div>
                </div>
                <div className="back-grid">
                    <div className="dash-double">
                        <div className="card-double-blank">
                            <div className="card-double">
                                <div>
                                    <span><img src={freedom} alt=""/></span>
                                </div>
                            </div>
                            <div className="card-double">    
                                <div className="sub-heading">
                                    <span>Financial Freedom</span>
                                </div>
                                <p>
                                    An easy and fastest earning opportunity with the worlds first unique designed 
                                    Globally 2X Matrix, 15 Level, 12 Pool & Gen 6 Level plan in a decentralized smart contract on the coredao blockchain. 
                                </p>
                                <p>
                                    Core Unity is a self-executing smart contract on the coredao blockchain, 
                                    it's a crowdfunding and network marketing system with a unique strategy. 
                                    Core Unity distributes 100% fund with an exciting Globaly affiliate programme, 
                                    2X Matrix, 15 Level, 12 Level Pool & Gen 6 Level Plan.
                                </p>
                                <div className="sub-heading">
                                    <span>Join</span>
                                </div>
                                <p>
                                    Sign Up and Become a part of Core Unity Smart Contract. 
                                </p>
                            </div>
                        </div>    
                    </div>
                </div>

                {/* <!-----Faq----Section----------------------------------------------> */}
                <div className="back-grid">
                    <section>
                        <h1 className="faq-title">Frequently Asked General Questions</h1>
                        {/* <!-- <div className="faq-heading">
                            <span>General</span>
                        </div> --> */}
                        <div className="quetions-box">
                            <div className="hide-space"></div>
                            <div className="question">
                                <button id='faq_1_btn' onClick={() => {Btn_Click("faq_1_btn");}}>
                                    <span>Who Manage The Platform ?</span>
                                    <span>
                                        <img className="click-img" src={faq_1} alt=""/>
                                    </span>
                                </button>
                                <p>Core Unity does not have a Manager. This means that the platform is fully decentralized (i.e. it has no leaders or admins).</p>
                            </div>
                            <div className="question">
                                <button id='faq_2_btn' onClick={() => {Btn_Click("faq_2_btn");}}>
                                    <span>What is Decentralization ?</span>
                                    <span>
                                        <img className="click-img" src={faq_1} alt=""/>
                                    </span>
                                </button>
                                <p>
                                    It is a system in which there are no admins, there is no single server or system monitoring, project management. The creators of the platform are the same project participants like you.
                                </p>
                            </div>
                            <div className="question">
                                <button id='faq_3_btn' onClick={() => {Btn_Click("faq_3_btn");}}>
                                    <span>What is Core ?</span>
                                    <span>
                                        <img className="click-img" src={faq_1} alt=""/>
                                    </span>
                                </button>
                                <p>CORE is one of the leading cryptocurrency, which has existed since 2022 At the same time, it is a software framework for L1 (Fully Decentralized Blockchain). 
                                    Since the blockchain of this crypto currency allows you not only to follow the history of transactions, but also to save any executable software products (smart contracts). 
                                    A huge number of major crypto companies use this platform.
                                </p>
                            </div>
                            <div className="question">
                                <button id='faq_4_btn' onClick={() => {Btn_Click("faq_4_btn");}}>
                                    <span>What is Smart Contract ?</span>
                                    <span>
                                        <img className="click-img" src={faq_1} alt=""/>
                                    </span>
                                </button>
                                <p>A Smart Contract is a computer software that manages the transfer of digital assets between a peer-to-peer network of involved parties directly and automatically under specific conditions.</p>
                            </div>
                            <div className="question">
                                <button id='faq_5_btn' onClick={() => {Btn_Click("faq_5_btn");}}>
                                    <span>How Much Can You Earn ?</span>
                                    <span>
                                        <img className="click-img" src={faq_1} alt=""/>
                                    </span>
                                </button>
                                <p>Core Unity does not have a Manager. This means that the platform is fully decentralized. Which mean you can earn unlimited income under specific conditions.</p>
                            </div>
                        </div>
                    </section> 
                </div>
                
                {/* <!-----Smart----Contracts------------------------------> */}
                <div className="back-grid-short">                                 
                    <div className="heading">
                        <span>Smart Contract Address</span>
                        <div className="sub-heading">
                            <span>Features Of</span>
                        </div>
                    </div>
                </div>
                <div className="back-grid-short">
                    <div className="smart-grid">
                        <div className="table scroll-bar">
                            <table>
                                <thead>
                                    <tr>
                                        <td>Sr</td>
                                        {/* <!-- <td>Core Unity</td> --> */}
                                        <td>Contract Address</td>
                                        <td>Link</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        {/* <!-- <td>Core Unity</td> --> */}
                                        <td>{Gen_8_Cal.address}</td>
                                        <td>
                                            <div>
                                                <a className="check" onClick={() => {Transfer_To_Btn(Gen_8_Cal.address)}}>Check</a>
                                            </div>  
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        {/* <!-- <td>Core Unity</td> --> */}
                                        <td>{Fixed_Pool.address}</td>
                                        <td>
                                            <div>
                                                <a className="check" onClick={() => {Transfer_To_Btn(Fixed_Pool.address)}}>Check</a>
                                            </div>  
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
                {/* <!-----Footer----Section--------------------------------> */}
                <div className="back-grid-short">
                    <div className="dash-card-footer-main"> 
                        <div className="card-logo-footer">
                            <span><img src={U} alt=""/></span>
                        </div> 
                        <div className="link-column flex">
                            <span>Our Links</span>
                            <a className="hover-link">Home</a>
                            <a className="hover-link">Features</a>
                            <a className="hover-link">About Us</a>
                            <a className="hover-link">Advantage Of Core</a>
                            <a className="hover-link">Financial freedom</a>
                        </div>
                        <div className="link-column flex">
                            <span></span>
                            <span></span>
                        </div>  
                    </div>
                </div>
                
                {/* <!-----Sub-Footer----Section--------------------------------> */}
                <div className="back-grid-short">
                    <div className="dash-sub-footer">
                        <div className="card-sub-footer">
                            <div className="copy-right">
                                <span>©2025Core Unity.</span>
                            </div>
                        </div>
                        <div className="card-sub-footer">
                            <div className="social-link">
                                <span><img src={s_m_1} alt=""/></span>
                                <span><img src={s_m_1} alt=""/></span>
                                <span><img src={s_m_1} alt=""/></span>
                                <span><img src={s_m_1} alt=""/></span>
                            </div>                         
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </>
  );
}
